export const scrollToHash = () => {
    if (window.location.hash) {
        scrollTo(window.location.hash);
    }
};

export const scrollTo = (id) => {
    const stickyHeader = document.querySelector("header[data-sticky='true']");
    const scrollToElement = document.getElementById(id.replace("#", ""));

    if (!scrollToElement) return;

    const scrollToElementPos = scrollToElement.getBoundingClientRect().top;
    const elementTopPos = scrollToElementPos - document.body.getBoundingClientRect().top;

    const announcementBar = document.querySelector(".announcementBar.sticky");
    const announcementBarHeight = announcementBar ? announcementBar.clientHeight : 0;

    const topPos = stickyHeader
        ? elementTopPos - (stickyHeader.offsetHeight + announcementBarHeight)
        : elementTopPos;

    window.scrollTo({
        top: topPos,
        behavior: "smooth",
    });
};
